import React, { useContext, useCallback, useState, useRef } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

const NotificationsContext = React.createContext();

export function withNotifications(Component) {
  const HoC = (props) => {
    const [notifications, setNotifications] = useState([]);

    // NOTE: we need to use a ref to avoid recreating the callbacks, which would likely trigger cascading changes elsewhere
    const notificationsRef = useRef();
    notificationsRef.current = notifications;

    const notify = useCallback((notification) => {
      setNotifications([...notificationsRef.current, notification]);
    }, [setNotifications]);

    const peek = useCallback(() => notificationsRef.current[0], []);
    const readNotifications = useCallback(() => {
      setNotifications([]);
      // the state change takes effect only on the next cycle
      return notifications;
    }, [notifications, setNotifications]);

    return (
      <NotificationsContext.Provider value={{ notify, notifications: readNotifications, peek }}>
        <Component {...props} />
      </NotificationsContext.Provider>
    );
  };

  HoC.displayName = `WithNotifications(${getDisplayName(Component)})`;
  hoistNonReactStatics(HoC, Component);

  return HoC;
}

export function useNotifications() {
  const notificationsApi = useContext(NotificationsContext);

  return notificationsApi;
}
